import { LetterSpacingIcon } from "components/common/Icons/LetterSpacingIcon";
import { Slider } from "components/common/Slider/Slider";
import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

interface LetterSpacingProps {
    textBox: TextBox;
}

export const LetterSpacing = ({ textBox }: LetterSpacingProps) => {
    const dispatch = useAppDispatch();
    function handleChange(value: number) {
        dispatch(
            setSettings({
                id: textBox.id,
                spacing: {
                    ...textBox.spacing,
                    letter: value,
                },
            }),
        );
    }
    return (
        <div className="flex gap-[31px] items-center text-black dark:text-white">
            <div>
                <LetterSpacingIcon />
            </div>
            <div className="w-full">
                <Slider
                    defaultValue={textBox.spacing.letter}
                    handleChange={handleChange}
                    max={100}
                    min={0}
                    width={85}
                />
            </div>
            <div className="text-sm px-2.5 border border-irGray-200 dark:border-darkSurface-400 rounded-lg">{textBox.spacing.letter}</div>
        </div>
    );
};
